<template>
	<div>
		<TopHeader/>
		<Menu/>
		<router-view :key="this.$route.fullPath"/>
		<div id="audio"></div>
	</div>
</template>

<script>
import TopHeader from './components/topheader.vue'
import Menu from './components/menu.vue'

export default {
	components: {
		TopHeader,
		Menu
	},
	data() {
		return {

		}
	},
	mounted(){
		if(Notification.permission == 'default' || Notification.permission == 'denied'){
			Notification.requestPermission();
		}
	}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,600;1,700;1,800&display=swap');

* {padding: 0;margin: 0;box-sizing: border-box;}

body {
	background-color: #F9FAFB;
	font-family: 'Montserrat', sans-serif;
}

#app { width: 100%;height: 100%;}

button, a, a:focus {outline: none;text-decoration: none;border: 0;color: inherit;}

:root {
	--color1: #45BD62;
}

section {
	position: relative;
	top: 80px;
	left: 18%;
	width: calc(100% - 18%);
	height: auto;
}

.container {
	position: relative;
	width: 100%;
	height: auto;
	margin-top: 70px;
	display: flex;
	justify-content: space-evenly;
}

.container .top,
.container .content {
	float: left;
	width: 100%;
	height: 40px;
	color: #333;
}

.container .top .title {
	float: left;
	width: 100%;
	height: 20px;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
}

.container .page .top .title {font-size: 18px;}
.container .page .top .subTitle {margin-top: 4px;}

.container .top .subTitle {
	float: left;
	width: 100%;
	height: 20px;
	line-height: 20px;
	font-size: 14px;
}

.container .main {
	position: relative;
	left: 0;
	width: 60%;
	height: auto;
}

.container .page {
	position: relative;
	width: 50%;
	height: auto;
	margin-top: 50px;
}

.container .page .content {
	float: left;
	width: 100%;
	height: auto;
	background-color: #fff;
	border-radius: 8px;
	font-size: 14px;
	margin-top: 30px;
	padding: 10px;
	box-shadow: 0 1px 5px rgba(0,0,0,.15);
}

.container .page .content .credits {
	float: right;
	width: auto;
	height: auto;
	font-size: 14px;
	font-weight: 300;
	font-style: italic;
	margin-top: 30px;
	color: rgba(0, 0, 0,.6);
}

.green {
	color: var(--color1);
	font-weight: 600;
}

.about {
	float: left;
	width: 100%;
	height: auto;
	font-size: 13px;
	color: rgba(255,255,255,.8);
	text-align: center;
	margin-top: 50px;
}

@media (max-width: 1400px){
	.nav {
		width: 24% !important;
		position: relative;
		height: auto;
		padding-bottom: 30px;
	}

	section {
		left: 24%;
		width: calc(100% - 24%);
	}

	.attLoc {
		width: 33% !important;
	}

	.swiper {
		width: 80% !important;
	}

	.player {
		margin-right: 8px !important;
		width: 85% !important;
	}
}

@media (max-width: 1200px){
	.nav {
		width: 26% !important;
	}

	section {
		left: 26%;
		width: calc(100% - 26%);
	}

	.attLoc {
		width: 36% !important;
	}

	.main.rank {
		width: calc(100% - 60px) !important;
	}
}

@media (max-width: 900px){
	.topheader {position: absolute !important;}

	.nav {
		position: absolute !important;
		width: 100% !important;
		height: auto !important;
	}

	section {
		float: left;
		left: 0;
		margin: 500px 0 0 0;
		width: 100%;
		padding-bottom: 120px;
	}

	.container {
		display: grid;
		align-content: center;
		justify-items: center;
		height: auto;
	}

	.announcement {width: 90% !important;}
	.swiper {width: 100% !important;}

	.attLoc {
		width: 90% !important;
		height: 366px !important;
		margin-top: 30px;
	}

	.main.rank {
		width: calc(100% - 60px) !important;
	}

	.topheader {display: block;}
	.topheader .right {width: 100%;}
	.topheader .left {position: absolute;}
	.topheader .bar {display: none;}

	.topheader .player {
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100% !important;
		height: 80px !important;
		background-color: #fff;
		padding: 0 20px;
		z-index: 999;
	}

	.player .volume .vol {margin: -95px 0 0 -62px !important;}

	.topheader .player .visit,
	.topheader .player .time,
	.topheader .player .icon {display: none;}

	.main .content {display: grid !important;justify-items: center;}
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>